export default __webpack_public_path__ + "static/media/professionalsAndPortfolios.50cc842d.png";